import { render, staticRenderFns } from "./ontick-toggle-visualization.component.vue?vue&type=template&id=a63f9404&scoped=true"
import script from "./ontick-toggle-visualization.component.vue?vue&type=script&lang=js"
export * from "./ontick-toggle-visualization.component.vue?vue&type=script&lang=js"
import style0 from "./ontick-toggle-visualization.component.vue?vue&type=style&index=0&id=a63f9404&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a63f9404",
  null
  
)

export default component.exports